import moment from 'moment';
export const getTime = (time, format) => {
    if (!time) {
        return '-';
    }
    return moment(time).format('YYYY-MM-DD' || format);
};

export const getMMSS = (seconds) => {
    if (seconds === undefined) {
        return false;
    }
    let minutes = `0${Math.floor(seconds / 60)}`.slice(-2),
        second = `0${(seconds % 60).toFixed(0)}`.slice(-2);

    return `${minutes}:${second}`;
};

export const formatTime = (time) => {
    if(parseInt(time) <= 0 || isNaN(parseInt(time)))return '00:00:00';
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const timeTransforStr = (timeMills) => {
    return timeMills ? moment(new Date(parseInt(timeMills))).format('YYYY-MM-DD HH:mm') : '--';
};
export const timeTransforTodayNoYear = (timeStamp) => {
    const currentDateTime = new Date(),
        currentYear = currentDateTime.getFullYear(),
        currentMonth = currentDateTime.getMonth() + 1, // 月份从 0 开始，因此需要加 1
        currentDate = currentDateTime.getDate(),
        paramsDateTime = new Date(parseInt(timeStamp ? timeStamp : '0')),
        paramsYear = paramsDateTime.getFullYear(),
        paramsMonth = paramsDateTime.getMonth() + 1, // 月份从 0 开始，因此需要加 1
        paramsDate = paramsDateTime.getDate();
    if (currentYear === paramsYear && currentMonth === paramsMonth) {
        if (currentDate === paramsDate) {
            return '今天';
        } else if (currentDate - paramsDate === 1) {
            return '昨天';
        } else if (currentDate - paramsDate === -1) {
            return '明天';
        }
        return `${paramsMonth}-${paramsDate}`;
    }
    return `${paramsMonth}-${paramsDate}`;
};
export const teacherArryFun = (arry) => {
    let formattedString;
    const teacherList = arry;
    if (arry && arry.length > 0) {
        formattedString = teacherList.join('/');
    }
    return formattedString || '';
};

export const examTime = (startTime, endTime) => {
    let time;
    if (startTime && endTime) {
        const date1 = new Date(startTime),
            date2 = new Date(endTime),
            // 判断是否跨年
            isCrossYear = date1.getFullYear() !== date2.getFullYear(),
            // 判断是否跨天
            isCrossDay = date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth() || date1.getDate() !== date2.getDate();
        //跨年处理
        if (isCrossYear) {
            time =
                moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm') +
                ' 至 ' +
                moment(new Date(parseInt(endTime))).format('YYYY-MM-DD HH:mm');
        } else if (isCrossDay) {
            time =
                moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm') + ' 至 ' + moment(new Date(parseInt(endTime))).format('MM-DD HH:mm');
        } else {
            time = moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm') + ' 至 ' + moment(new Date(parseInt(endTime))).format('HH:mm');
        }
    } else {
        time = '';
    }

    return time;
};
export const convertTimeToMinutesSeconds = (timestamp) => {
    var minutes = Math.floor(timestamp / (1000 * 60)),
        seconds = ((timestamp % (1000 * 60)) / 1000).toFixed(0);
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    return minutes + ' 分 ' + seconds + ' 秒';
};

/**
 * 时间戳转换   转换成YYYY-MM-DD HH:mm
 * @param timeMills 1696130404000
 * @return timeStr YYYY-MM-DD HH:mm
 */
export const timeStampStrForLine = (timeMills) => {
    return timeMills ? moment(new Date(parseInt(timeMills))).format('YYYY-MM-DD HH:mm') : '--';
};

/**
 * 时间转换时间戳
 * @param timeMills 2024-04-08 09:30:00 timeFormat YYYY-MM-DD HH:mm
 * @return timeStr YYYY-MM-DD HH:mm
 */
export const timeformatTran = (timeMills, timeFormat) => {
    const date = new Date(timeMills),
        timestamp = date.getTime(),
        timeFormatSt = timeFormat || 'YYYY-MM-DD HH:mm',
        time = timestamp ? moment(new Date(parseInt(timestamp))).format(timeFormatSt) : '--';
    return time;
};
//跨天是否显示年
export const timeFormatShow = (startTime, endTime, isYear) => {
    let time;
    if (startTime && endTime) {
        const date1 = new Date(startTime),
            date2 = new Date(endTime),
            // 判断是否跨年
            isCrossYear = date1.getFullYear() !== date2.getFullYear(),
            // 判断是否跨天
            isCrossDay = date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth() || date1.getDate() !== date2.getDate();
        //跨年处理
        if (isCrossYear) {
            time =
                moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm') +
                ' 至 ' +
                moment(new Date(parseInt(endTime))).format('YYYY-MM-DD HH:mm');
        } else if (isCrossDay) {
            if (isYear) {
                time =
                    moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm') +
                    ' 至 ' +
                    moment(new Date(parseInt(endTime))).format('YYYY-MM-DD HH:mm');
            } else {
                time =
                    moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm') +
                    ' 至 ' +
                    moment(new Date(parseInt(endTime))).format('MM-DD HH:mm');
            }
        } else {
            time = moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm') + ' 至 ' + moment(new Date(parseInt(endTime))).format('HH:mm');
        }
    } else {
        time = '';
    }

    return time;
};

export const timeTransforTodayNoYearTime = (timeStamp) => {
    const currentDateTime = new Date(),
        currentYear = currentDateTime.getFullYear(),
        currentMonth = currentDateTime.getMonth() + 1, // 月份从 0 开始，因此需要加 1
        currentDate = currentDateTime.getDate(),
        paramsDateTime = new Date(parseInt(timeStamp ? timeStamp : '0')),
        paramsYear = paramsDateTime.getFullYear(),
        paramsMonth = paramsDateTime.getMonth() + 1, // 月份从 0 开始，因此需要加 1
        paramsDate = paramsDateTime.getDate(),
        paramsHours = paramsDateTime.getHours(),
        paramsMinutes = paramsDateTime.getMinutes();
    if (currentYear === paramsYear && currentMonth === paramsMonth) {
        if (currentDate === paramsDate) {
            return '今天';
        } else if (currentDate - paramsDate === 1) {
            return `昨天 ${paramsHours}:${paramsMinutes}`;
        } else if (currentDate - paramsDate === -1) {
            return '明天';
        }
        return `${paramsMonth}-${paramsDate}`;
    }
    return `${paramsMonth}-${paramsDate}`;
};

export const convertSecondsToHMSLive = (seconds) => {
    if (isNaN(seconds) || seconds < 0) {
        return '00:00:00';
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    // 根据数值大小动态格式化小时部分
    const formattedHours = hours >= 100 ? String(hours) : ('0' + hours).slice(-2);
    const formattedMinutes = ('0' + minutes).slice(-2);
    const formattedSeconds = ('0' + remainingSeconds).slice(-2);
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};


export const liveTime = (startTime, endTime,dateFormat='YYYY-MM-DD HH:mm:ss',hoursFormat='HH:mm:ss') => {
    let time;
    if (startTime && endTime) {
        const date1 = new Date(startTime),
            date2 = new Date(endTime),
            // 判断是否跨天
            isCrossDay = date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth() || date1.getDate() !== date2.getDate();
        if (isCrossDay) {
            time =
                moment(new Date(parseInt(startTime))).format(dateFormat) + ' 至 ' + moment(new Date(parseInt(endTime))).format(dateFormat);
        } else {
            time = moment(new Date(parseInt(startTime))).format(dateFormat) + ' 至 ' + moment(new Date(parseInt(endTime))).format(hoursFormat);
        }
    } else {
        time = '';
    }

    return time;
};
